import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-edit-page-footer-buttons",
    templateUrl: "./edit-page-footer-buttons.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPageFooterButtonsComponent {

}
